import type { Translation } from '../types.ts';
import type en from '../en/redirects.ts';

export default {
    title: 'Doorverwijzingen',
    list: 'Doorverwijzingen',
    help: 'Oude adressen op deze website en waar ze nu naartoe gaan. Voeg er een toe voor elke URL van een oude site die niet meer bestaat, zodat links en zoekresultaten op de juiste pagina uitkomen in plaats van op een 404.',
    empty: 'Nog geen doorverwijzingen.',
    new: 'Nieuwe doorverwijzing',
    create: 'Doorverwijzing toevoegen',
    noTarget: 'geen bestemming',
    inactive: 'wordt niet gevolgd: de pagina is verwijderd of niet gepubliceerd',
    status: {
        permanent: '301 permanent',
        temporary: '302 tijdelijk',
    },
    form: {
        source: 'Oud pad',
        sourceHint: 'Een pad zoals /over-ons/, of plak de volledige oude URL.',
        status: 'Soort',
        page: 'Gaat naar pagina',
        noPage: 'Een ander adres…',
        url: 'Gaat naar adres',
        urlHint: 'Een pad op deze site (/contact) of een volledige URL (https://…).',
    },
    created: 'Doorverwijzing toegevoegd.',
    saved: 'Doorverwijzing opgeslagen.',
    deleted: 'Doorverwijzing verwijderd.',
    confirmDelete: 'De doorverwijzing voor {path} verwijderen? Dat adres geeft dan weer een 404.',
    loadFailed: 'De doorverwijzingen konden niet worden geladen.',
    createFailed: 'De doorverwijzing kon niet worden toegevoegd.',
    saveFailed: 'De doorverwijzing kon niet worden opgeslagen.',
    deleteFailed: 'De doorverwijzing kon niet worden verwijderd.',
} satisfies Translation<typeof en>;
